import React, { useEffect } from "react";
import Button from "./Button";
import styled from "styled-components";
import { Mark } from "../@interfaces/interfaces";
import {
  createMaskOfEntireSequence,
  submitSequenceForReview,
  returnSequence,
} from "../networking/sequenceControllerNetwork";
import { sendRejectMail } from "../networking/mailControllerNetwork";
import { useAuth } from "../context/auth";
import { authContextProps } from "../@interfaces/authContext";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import Spinner from "./Spinner";
import NoSmokeRadio from "./NoSmokeRadio";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 0.35em 0 0;
  flex-shrink: 0;
  width: 100%;
  gap: 0.3em;

  .radio__box {
    display: flex;
    align-items: center;
    gap: 3px;
    margin: 0.5em 0;
  }

  .button__tooltip {
    font-weight: 500;
    font-size: 0.82rem;
    text-align: center;
    line-height: 1.25;
  }

  .button__box {
    display: flex;
    width: auto;
    justify-content: center;
    flex-direction: row;
  }

  .compact-actions {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.6em;
    flex-wrap: wrap;
  }

  .compact-actions .button {
    margin: 0;
    padding: 0.32em 0.6em;
  }
`;

interface ControlPanelProps {
  folder_type?: string;
  markList: Mark[];
  triggerFetch: () => void;
}

function ControlPanel({
  folder_type = "oznacene",
  markList,
  triggerFetch,
}: ControlPanelProps) {
  const navigate = useNavigate();
  const { sequence_name } = useParams<{
    sequence_name: string;
  }>();
  const { token } = useAuth() as authContextProps;
  const [loading, setLoading] = React.useState(false);
  const [isEverythingReviewed, setIsEverythingReviewed] = React.useState(false);
  const [reviewedCount, setReviewedCount] = React.useState(0);

  const handleAccept = () => {
    if (sequence_name) {
      setLoading(true);
      createMaskOfEntireSequence(token, sequence_name).then((res) => {
        if (res) {
          setLoading(false);
          navigate("/");
        }
      });
    }
  };

  const handleReject = () => {
    let message = "";
    message += prompt(
      "Reject with message. \nMail will be sent to user who submited this sequence",
    );

    if (sequence_name && message.length > 0) {
      setLoading(true);
      sendRejectMail(token, message, sequence_name);
      returnSequence(token, sequence_name).then((res) => {
        if (res) {
          setLoading(false);
          navigate("/");
          window.location.reload();
        }
      });
    } else {
      window.alert(
        "Mail not sent. You must enter a rejection message to reject the sequence",
      );
    }
  };

  const handleSubmit = () => {
    if (sequence_name) {
      setLoading(true);
      submitSequenceForReview(token, sequence_name).then((res) => {
        if (res) {
          setLoading(false);
          navigate("/");
        }
      });
    }
  };

  useEffect(() => {
    if (markList.length === 0) {
      setReviewedCount(0);
      setIsEverythingReviewed(false);
      return;
    }

    const reviewed = markList.filter((mark) => {
      if (mark.annotation_status) {
        return mark.annotation_status !== "untouched";
      }
      return mark.marked;
    }).length;

    setReviewedCount(reviewed);
    setIsEverythingReviewed(reviewed === markList.length);
  }, [markList]);

  return (
    <Wrapper>
      {folder_type === "oznacene" && (
        <div className="button__box">
          <Button parentFunction={handleAccept}>Accept and create masks</Button>

          <Button parentFunction={handleReject} red_color={true}>
            Reject sequence
          </Button>
        </div>
      )}
      {folder_type === "neoznacene" && (
        <>
          <div className="compact-actions">
            <NoSmokeRadio triggerFetch={triggerFetch} />

            <div
              className={`button__box 
              
              `}
            >
              <Button
                disabled={!isEverythingReviewed}
                parentFunction={handleSubmit}
              >
                Submit
              </Button>
            </div>
          </div>

          <div className="button__tooltip">
            {isEverythingReviewed
              ? "All sequences are reviewed. You can submit"
              : `${reviewedCount}/${markList.length} reviewed. Review all sequences to submit`}
          </div>
        </>
      )}
      {loading && <Spinner />}
    </Wrapper>
  );
}

export default ControlPanel;
